export const languagesMapData = {
  "languageList": ["English", "Patois", "Spanish", "Korean", "German", "French"],
  "languageColors": [
    "#393D8E",
    "hsl(111.33 100% 16.27%)",
    "#D4D40B",
    "#ED79CE",
    "#E60909",
    "#8c564b"
  ]
}; 